<template>
  <div class="index">
    <div class="top-bg"></div>
    <div class="form-container">
      <div class="bot-list">
        <div class="bot" v-for="i in 14"></div>
      </div>

      <div class="input-box">
        <div class="input-name">姓名</div>
        <input type="text" v-model="formdate.name" placeholder="请输入姓名">
      </div>
      <div class="input-box">
        <div class="input-name">手机号码</div>
        <input type="number" v-model="formdate.phone" max="11" placeholder="请输入手机号码">
      </div>
      <div class="input-box">
        <div class="input-name">街道社区</div>
        <div class="pick-box" @click="showArea">
          <div>{{formdate.street_str || '请选择所在的街道社区'}}</div>
          <div class="iconfont icon-xiangyou"></div>
        </div>
      </div>
    </div>

    <div class="submit-btn"  @click="submit">提交</div>

    <areaPicker ref="areaPicker" @chooseArea="chooseArea"></areaPicker>
  </div>
</template>

<script>
import Loading from "@components/Loading";
import {AddSocietyInfo} from "@api/public";
import areaPicker from "@components/AreaPicker";
export default {
  name: "CateList",
  components: {
    areaPicker
  },
  props: {},
  data: function () {
    return {
		id:0,
		formdate:{
			name:'',
			phone:'',
			street_str:''
		},
		loaded: false,
		loading: false,
    };
  },
  watch: {
   
  },
  mounted: function () {
	    this.id=this.$route.query.id;
  },
  methods: {
    showArea(){
      // console.log(this.$refs.areaPicker)
      this.$refs.areaPicker.showArea()
    },
    chooseArea(data){
      if(data.street_str){
		  this.formdate.street_str=data.street_str;
	  }
    },
	//提交
	submit(){
		let data=this.formdate;
		if(!data.name){
			this.$dialog.error('请输入姓名');
			return;
		}
		if(!data.phone){
			this.$dialog.error('请输入手机号码');
			return;
		}
		if(!(/^1[3456789]\d{9}$/.test(data.phone))){ 
			this.$dialog.error('手机号码有误，请重填');
			return ; 
		} 
		if(!data.street_str){
			this.$dialog.error('请选择街道社区');
			return;
		}
		this.$dialog.loading.open("正在加载中");
		AddSocietyInfo(this.id,data).then((res) => {
			this.$dialog.loading.close();
			this.$dialog.success(res.msg);
			setTimeout(() => {
			  this.$router.go(-2)
			}, 1000);
		}).catch(res => {
			this.$dialog.loading.close();
			this.$dialog.error(res.msg);
	    });
	},
  },
};
</script>
<style lang="scss" scoped>
.index{
  background-color: #FEE1E5;
  min-height: 100vh;
}
.top-bg{
  margin: .5rem .2rem -0.12rem;
  border-radius: .24rem;
  height: .24rem;
  background-color: #F7D0D1;
}
.form-container{
  background-color: #fff;
  border-radius: 0 0 .3rem .3rem;
  padding: .4rem .3rem .8rem;
  margin: 0 .4rem;
}
.bot-list{
  display: flex;
  align-items: center;
  justify-content: space-between;
  .bot{
    width: .16rem;
    height: .16rem;
    background-color: #F7D0D1;
    border-radius: 50%;
  }
}
.input-box{
  margin-top: .5rem;
  .input-name{
    font-size: .32rem;
    font-weight: bold;
  }
  input{
    width: 100%;
    height: .85rem;
    line-height: .85rem;
    font-size: .25rem;
    border: 1px solid #D9D9D9;
    padding-left: .2rem;
    margin-top: .2rem;
  }
  .pick-box{
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: .85rem;
    line-height: .85rem;
    font-size: .25rem;
    border: 1px solid #D9D9D9;
    padding-left: .2rem;
    padding-right: .2rem;
    margin-top: .2rem;
  }
}
.submit-btn {
  line-height: 1rem;
  margin: 2rem .2rem 0;
  background-color: #E4446E;
  text-align: center;
  color: #fff;
  border-radius: .2rem;
  font-size: .3rem;
}
</style>
